import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

/**
 * Как useHashHighlight, но сравнивает не весь хэш целиком, а его суффикс —
 * комментарий адресуется как "{ownerCardId}~comment-{id}", и ownerCardId
 * снаружи неизвестен.
 */
export function useCommentHashHighlight(commentId: number): boolean {
  const location = useLocation();
  const [isHighlighted, setIsHighlighted] = useState(false);

  useEffect(() => {
    const hash = location.hash.slice(1);
    const suffix = `~comment-${commentId}`;

    if (hash.endsWith(suffix)) {
      setIsHighlighted(true);
      const timer = setTimeout(() => setIsHighlighted(false), 2000);

      return () => clearTimeout(timer);
    }
  }, [location.hash, location.key, commentId]);

  return isHighlighted;
}
